import { render, staticRenderFns } from "./change_pass.vue?vue&type=template&id=50531437&"
import script from "./change_pass.vue?vue&type=script&lang=js&"
export * from "./change_pass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50531437')) {
      api.createRecord('50531437', component.options)
    } else {
      api.reload('50531437', component.options)
    }
    module.hot.accept("./change_pass.vue?vue&type=template&id=50531437&", function () {
      api.rerender('50531437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/auth/change_pass.vue"
export default component.exports